var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Griglia_di_ripetizione_2",
    "data-name": "Griglia di ripetizione 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-552 -18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Unhide",
    transform: "translate(552 18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Unhide_Background_Mask_",
    "data-name": "Unhide (Background/Mask)",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1109",
    "data-name": "Raggruppa 1109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(3 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9,0c6,0,9,7,9,7s-3,7-9,7S0,7,0,7,3,0,9,0Z",
    fill: "none",
    stroke: "#4c69ff",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(6 4)",
    fill: "none",
    stroke: "#4c69ff",
    strokeWidth: 1.5,
    strokeDasharray: "0 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Griglia_di_ripetizione_1",
    "data-name": "Griglia di ripetizione 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Unhide_Background_Mask_2",
    "data-name": "Unhide (Background/Mask)",
    width: 24,
    height: 24,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4455",
    "data-name": "Tracciato 4455",
    d: "M0,15,7.969,7.031,15,0",
    transform: "translate(556.5 22.5)",
    fill: "none",
    stroke: "#4c69ff",
    strokeLinecap: "round",
    strokeWidth: 1.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOutlined);
export default __webpack_public_path__ + "static/media/EyeOutlined.2e0b4a5d987a9224fa74a3b66496caa7.svg";
export { ForwardRef as ReactComponent };